import { resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, withCtx as _withCtx, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b59b0ece")

_pushScopeId("data-v-b59b0ece")
const _hoisted_1 = { class: "flex" }
const _hoisted_2 = { class: "right-container flex-grow flex flex-col justify-between h-screen" }
const _hoisted_3 = { class: "flex-grow flex flex-col items-center justify-between bg-primary-100 overflow-y-scroll overflow-x-scroll px-12 pt-12" }
const _hoisted_4 = { class: "panel-container rounded-md bg-white pb-2 mb-16 lg:mb-8" }
const _hoisted_5 = { class: "w-full table-header-color px-4 py-3" }
const _hoisted_6 = { class: "flex items-center sticky left-0 justify-between" }
const _hoisted_7 = { class: "mr-2" }
const _hoisted_8 = { class: "flex items-center justify-end" }
const _hoisted_9 = /*#__PURE__*/_createVNode("svg", {
  fill: "none",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  class: "w-4 h-4 ml-1",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createVNode("path", { d: "M19 9l-7 7-7-7" })
], -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", null, "列を選択", -1)
const _hoisted_11 = { class: "list-none flex items-center w-full px-2 py-2 text-sm font-bold border-b" }
const _hoisted_12 = /*#__PURE__*/_createVNode("p", null, "列", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", null, "更新", -1)
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col items-center justify-center py-8"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "text-gray-500 text-sm" }, "提出物情報取得中...", -1)
const _hoisted_16 = { class: "hidden lg:flex justify-between items-center" }
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = { class: "mr-6 text-gray-500 text-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_MNavBar = _resolveComponent("MNavBar")
  const _component_MHeaderPanel = _resolveComponent("MHeaderPanel")
  const _component_m_table_condition_item = _resolveComponent("m-table-condition-item")
  const _component_m_icon = _resolveComponent("m-icon")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MLoadingIcon = _resolveComponent("MLoadingIcon")
  const _component_submission_master_detail_multi_run_drop_down = _resolveComponent("submission-master-detail-multi-run-drop-down")
  const _component_m_table = _resolveComponent("m-table")
  const _component_ms_send_modal = _resolveComponent("ms-send-modal")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_MNavBar),
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_MHeaderPanel, {
          title: _ctx.pageTitle,
          breadcrumbs: _ctx.breadcrumbs
        }, null, 8, ["title", "breadcrumbs"]),
        _createVNode("main", _hoisted_3, [
          _createVNode("section", _hoisted_4, [
            _createVNode("div", _hoisted_5, [
              _createVNode("div", _hoisted_6, [
                _createVNode("div", _hoisted_7, [
                  _withDirectives(_createVNode("input", {
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchKeyword = $event)),
                    type: "search",
                    name: "searchStudent",
                    placeholder: "ユーザーネームで検索...",
                    class: "w-36 sm:w-52 bg-white rounded border border-white focus:border-primary-500 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-300"
                  }, null, 512), [
                    [_vModelText, _ctx.searchKeyword]
                  ])
                ]),
                _createVNode("div", _hoisted_8, [
                  _createVNode(_component_m_table_condition_item, {
                    active: _ctx.selectedColumnList.length > 0,
                    class: "hidden lg:block"
                  }, {
                    body: _withId(() => [
                      _createVNode("ul", null, [
                        _createVNode("li", _hoisted_11, [
                          _hoisted_12,
                          _createVNode("button", {
                            class: "ml-24 bg-blue-400 hover:bg-blue-500 text-white p-1 rounded text-xs",
                            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.selectAllColumn && _ctx.selectAllColumn(...args)))
                          }, " 全選択 "),
                          _createVNode("button", {
                            class: "ml-2 bg-gray-400 hover:bg-gray-500 text-white p-1 rounded text-xs",
                            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.deselectAllColumn && _ctx.deselectAllColumn(...args)))
                          }, " 全解除 ")
                        ]),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columnList, (column) => {
                          return (_openBlock(), _createBlock("li", {
                            key: column.id,
                            class: "list-none flex items-center w-full px-4 py-2 text-sm"
                          }, [
                            _withDirectives(_createVNode("input", {
                              id: column.id,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.selectedColumnList = $event)),
                              type: "checkbox",
                              value: column.id,
                              class: "h-4 w-4 text-primary-500 focus:ring-primary-600 border-gray-300 rounded"
                            }, null, 8, ["id", "value"]), [
                              [_vModelCheckbox, _ctx.selectedColumnList]
                            ]),
                            _createVNode("label", {
                              for: column.id,
                              class: "ml-2 block text-gray-700 w-44 truncate"
                            }, _toDisplayString(column.value), 9, ["for"])
                          ]))
                        }), 128))
                      ])
                    ]),
                    default: _withId(() => [
                      _hoisted_9,
                      _hoisted_10
                    ]),
                    _: 1
                  }, 8, ["active"]),
                  _createVNode(_component_m_button, {
                    color: "gray-500",
                    text: "",
                    class: "mr-1",
                    onClick: _ctx.refresh
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_m_icon, {
                        type: "refresh",
                        class: "mr-2"
                      }),
                      _hoisted_13
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ])
              ])
            ]),
            (!_ctx.initialized)
              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                  _createVNode(_component_MLoadingIcon),
                  _hoisted_15
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_m_table, {
              datas: _ctx.filteredDatas,
              definitions: _ctx.definitions,
              "count-per-page": 40,
              "selected-column-list": _ctx.selectedColumnList,
              order: "",
              selectable: "",
              "use-submission": "",
              "filterable-column": "",
              "selected-ids": _ctx.selectedIds,
              onChange: _ctx.changeSelectedId
            }, {
              footer: _withId(() => [
                _createVNode("div", null, [
                  _createVNode("div", _hoisted_16, [
                    _createVNode("div", _hoisted_17, [
                      _createVNode("p", _hoisted_18, _toDisplayString(_ctx.selectedIds.length) + "人選択中 ", 1),
                      _createVNode(_component_submission_master_detail_multi_run_drop_down, {
                        disabled: _ctx.selectedIds.length == 0,
                        "use-management": false,
                        onOpenAll: _ctx.openAll,
                        onMessage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.toggleSendModal(true)))
                      }, null, 8, ["disabled", "onOpenAll"])
                    ])
                  ])
                ])
              ]),
              _: 1
            }, 8, ["datas", "definitions", "selected-column-list", "selected-ids", "onChange"])
          ])
        ])
      ])
    ]),
    (_ctx.isSendModalDisplayed)
      ? (_openBlock(), _createBlock(_component_ms_send_modal, {
          key: 0,
          schools: _ctx.schools,
          classrooms: _ctx.classrooms,
          students: _ctx.students,
          groups: _ctx.groups,
          "default-student-ids": _ctx.selectedStudentId,
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleSendModal(false)))
        }, null, 8, ["schools", "classrooms", "students", "groups", "default-student-ids"]))
      : _createCommentVNode("", true)
  ], 64))
})